import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, null, -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_5 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "Description", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "overflow-scroll h-500px" }
const _hoisted_11 = { class: "row" }

import { ref, onMounted } from "vue";
import SystemService from "../services/SystemService";
import { ServiceTypes } from "@/core/types/ServiceTypes";
import AddGroup from "../components/platform/AddGroup.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformSetting',
  setup(__props) {

const isLoading = ref(false);
const data = ref(<any>[]);
const modalRef = ref<InstanceType<typeof AddGroup>>();
const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.getServices();
    data.value = res;
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

const addGroup = (item: any) => {
  modalRef.value?.show(item);
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_5, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.name")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.platform")), 1),
              _hoisted_6,
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, _toDisplayString(_unref(ServiceTypes)[item.platform]) + " (" + _toDisplayString(item.platform) + ")", 1),
                      _createElementVNode("td", null, _toDisplayString(item.description), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_popover, {
                          trigger: "click",
                          width: 500
                        }, {
                          reference: _withCtx(() => [
                            _createVNode(_component_el_button, { type: "primary" }, {
                              default: _withCtx(() => [
                                _createTextVNode("View Group")
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.groups, (i, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "col-6"
                                  }, _toDisplayString(i), 1))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_button, {
                          type: "success",
                          onClick: ($event: any) => (addGroup(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Add Group")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ])
    ]),
    _createVNode(AddGroup, {
      ref_key: "modalRef",
      ref: modalRef,
      onSubmit: fetchData
    }, null, 512)
  ], 64))
}
}

})